export const NATIONALITY_ANY_VALUE = 0;
export const NATIONALITY_ANY_LABEL = "国籍問わず";

export const NATIONALITY_ANY_OPTION = {
  label: NATIONALITY_ANY_LABEL,
  value: String(NATIONALITY_ANY_VALUE),
  hidden: false,
};
